import { Todo } from '@deliveries-app/models';
import { TodoActions, TodoActionTypes } from './actionTypes';

export interface TodosReducerState {
  loading: boolean;
  message: string;
  error: string;
  todos: Todo[];
}

const initialState: TodosReducerState = {
  loading: false,
  message: '',
  error: '',
  todos: [],
};

export default function todosReducer(
  state = initialState,
  action: TodoActions
) {
  switch (action.type) {
    case TodoActionTypes.TODO_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TodoActionTypes.GET_ALL_TODOS_SUCCESS:
      return {
        ...state,
        loading: false,
        todos: action.payload,
      };
    case TodoActionTypes.GET_ALL_TODOS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case TodoActionTypes.CREATE_TODO_SUCCESS:
      return {
        ...state,
        loading: false,
        todos: [...state.todos, action.payload],
      };
    case TodoActionTypes.CREATE_TODO_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case TodoActionTypes.DELETE_TODO_SUCCESS:
      return {
        ...state,
        loading: false,
        todos: state.todos.filter((todo) => todo.id !== action.payload),
      };
    case TodoActionTypes.DELETE_TODO_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case TodoActionTypes.UPDATE_TODO_SUCCESS:
      return {
        ...state,
        loading: false,
        todos: state.todos.map((todo) =>
          todo.id === action.payload.id
            ? {
                ...todo,
                completed_at: action.payload.completed,
              }
            : todo
        ),
      };
    case TodoActionTypes.UPDATE_TODO_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
